import * as React from "react";
import Select from "react-select";

var ComunaSelector = function ComunaSelector(props) {
  var _props$comunas = props.comunas,
      comunas = _props$comunas === void 0 ? [] : _props$comunas,
      comunaId = props.comunaId,
      _onChange = props.onChange,
      regionId = props.regionId,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled;
  var comunasFiltered = regionId ? comunas.filter(function (comuna) {
    return comuna.region_id === regionId;
  }) : comunas;
  var comunasOptions = comunasFiltered.map(function (comuna) {
    return {
      label: comuna.name,
      value: "".concat(comuna.id)
    };
  });
  var selectedComuna = comunaId && comunasOptions.find(function (comuna) {
    return parseInt(comuna.value) === comunaId;
  });
  return /*#__PURE__*/React.createElement(Select, {
    options: comunasOptions,
    value: selectedComuna,
    isDisabled: !regionId || disabled,
    isSearchable: true,
    isClearable: true,
    onChange: function onChange(item) {
      return _onChange && _onChange(parseInt(item.value));
    }
  });
};

export default ComunaSelector;